import { MainCard } from '@components/BaseStyles';
import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const PrescriptionsInfoMainCard = styled(MainCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
  minWidth: '240px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '360px',
    minHeight: '360px',
  },
}));

export const PrescriptionsInfoContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
});

export const PrescriptionsInfoItem = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
});

export const PrescriptionsInfoText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.16px',
  color: theme.palette.text.secondary,
}));
